import React, { useState, useEffect, useCallback } from "react";
import { Pagination, Row, Col, Collapse, Table, Tag } from "antd";
import axios from "axios";
import PageHeader from "../Layout/PageHeader";
import PointHistoryFilters from "./PointHistoryFilters";
import { CaretRightOutlined } from "@ant-design/icons";
import { formatDateTime } from "../../helpers/date";

const columns = [
  {
    title: "User ID",
    dataIndex: "userId",
    key: "userId",
    width: 120,
    render: (text) => <a href={`/user/${text}`}>{text}</a>,
  },
  {
    title: "Type",
    dataIndex: "type",
    key: "type",
    width: 100,
    render: (text) => (
      <Tag color={text === "EARN" ? "green" : "red"}>{text}</Tag>
    ),
  },
  {
    title: "Amount",
    dataIndex: "amount",
    key: "amount",
    width: 100,
  },
  {
    title: "Remarks",
    dataIndex: "remarks",
    key: "remarks",
  },
  {
    title: "Date",
    dataIndex: "createdAt",
    key: "createdAt",
    width: 180,
    render: (text) => (text ? formatDateTime(text) : "-"),
  },
];

const PointHistory = () => {
  const [pagination, setPagination] = useState({
    currentPage: 1,
    limit: 10,
  });
  const [pointHistory, setPointHistory] = useState([]);
  const [filters, setFilters] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const fetchPointHistory = useCallback(async () => {
    setIsLoading(true);
    try {
      const params = {
        ...(filters.userId && { userId: filters.userId }),
        ...(filters.type && { type: filters.type }),
        ...(filters.startDate && {
          startDate: filters.startDate?.startOf("day")?.toISOString(),
        }),
        ...(filters.endDate && {
          endDate: filters.endDate?.endOf("day")?.toISOString(),
        }),
        limit: pagination.limit,
        page: pagination.currentPage,
      };

      const res = await axios.get("/api/point-history", { params });
      setPointHistory(res.data.data);
      setPagination((prev) => ({
        ...prev,
        totalSize: res.data.pagination?.totalSize,
      }));
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }, [pagination.currentPage, pagination.limit, filters]);

  useEffect(() => {
    fetchPointHistory();
  }, [fetchPointHistory]);

  const handlePageChange = (currentPage, limit) => {
    setPagination((prev) => ({ ...prev, currentPage, limit }));
  };

  return (
    <div>
      <PageHeader
        title="Point History"
        childRoutes={[
          { path: "/point-history", breadcrumbName: "Point History" },
        ]}
      />

      <Collapse
        expandIcon={({ isActive }) => (
          <CaretRightOutlined rotate={isActive ? 90 : 0} />
        )}
      >
        <Collapse.Panel header="Filters" key="filters">
          <PointHistoryFilters
            filters={filters}
            onFiltersChange={(filters) => setFilters(filters)}
          />
        </Collapse.Panel>
      </Collapse>

      <Row justify="end" style={{ marginTop: 16 }}>
        <Col>
          <Pagination
            total={pagination?.totalSize}
            pageSize={pagination.limit}
            current={pagination.currentPage}
            onChange={handlePageChange}
          />
        </Col>
      </Row>

      <Table
        rowKey="objectId"
        columns={columns}
        dataSource={pointHistory}
        pagination={false}
        loading={isLoading}
        scroll={{ x: true }}
      />

      <Row justify="end" style={{ marginTop: 16 }}>
        <Col>
          <Pagination
            total={pagination?.totalSize}
            pageSize={pagination.limit}
            current={pagination.currentPage}
            onChange={handlePageChange}
          />
        </Col>
      </Row>
    </div>
  );
};

export default PointHistory;
